import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { scanQR } from '../../api/rooms.api';
import { ROUTES } from '../../config/routes';
import { getDeviceId } from '../../utils/deviceId';
import { LoadingScreen } from '../../shared/components/Lounge';

export function Enter() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;

    (async () => {
      const token = params.get('token');
      if (!token) return navigate('/error?msg=falta_token', { replace: true });

      const deviceId = getDeviceId();

      try {
        const data = await scanQR(token, deviceId);
        if (!active) return;

        if (data.available <= 0) return navigate('/error?msg=sin_cupo', { replace: true });

        navigate(ROUTES.ROOM(data.roomId), { replace: true, state: data });
      } catch (e) {
        if (!active) return;
        const status    = e.response?.status;
        const errorData = e.response?.data?.data;
        const message   = e.response?.data?.message;

        if (status === 403 && message === 'inactive_subscription') {
          navigate('/error?msg=sala_inactiva', { replace: true });
          return;
        }

        if (status === 403 && errorData?.cooldownUntil) {
          navigate(ROUTES.COOLDOWN, { replace: true, state: { cooldownUntil: errorData.cooldownUntil } });
          return;
        }

        // Sin respuesta = timeout o sin red: no es culpa del QR.
        if (!e.response) {
          navigate('/error?msg=sin_conexion', { replace: true });
          return;
        }

        navigate(status === 403 ? '/error?msg=sin_cupo' : '/error?msg=qr_invalido', { replace: true });
      }
    })();

    return () => { active = false; };
  }, [params, navigate]);

  return <LoadingScreen />;
}
